const normalizarIds = (ids) => Array.from(new Set(
  (ids || [])
    .map((id) => Number(id))
    .filter((id) => Number.isInteger(id) && id > 0)
));

function MotivosMbaSelector({
  id,
  motivos = [],
  selectedIds = [],
  onChange,
  disabled = false,
  required = false,
  invalid = false,
  allowEmptySelection = false,
}) {
  const idsSelecionados = normalizarIds(selectedIds);

  const alternarMotivo = (motivoId) => {
    const estaSelecionado = idsSelecionados.includes(motivoId);
    const proximaSelecao = estaSelecionado
      ? idsSelecionados.filter((idSelecionado) => idSelecionado !== motivoId)
      : [...idsSelecionados, motivoId];

    onChange(proximaSelecao);
  };

  return (
    <fieldset
      id={id}
      className={`motivos-mba-selector border rounded p-3 mb-0 ${invalid ? 'border-danger' : 'border-secondary'}`}
      aria-required={required}
      disabled={disabled}
    >
      <legend className="visually-hidden">Seleção de motivos MBA</legend>
      <div className="d-flex flex-column gap-2 overflow-auto pe-2" style={{ maxHeight: '280px' }}>
        {motivos.map((motivo) => {
          const motivoId = Number(motivo.id);
          const estaSelecionado = idsSelecionados.includes(motivoId);
          const impedeRemocao = required && !allowEmptySelection && estaSelecionado && idsSelecionados.length === 1;

          return (
            <div key={motivo.id} className="form-check">
              <input
                id={`${id}-motivo-${motivo.id}`}
                type="checkbox"
                className="form-check-input"
                checked={estaSelecionado}
                onChange={() => alternarMotivo(motivoId)}
                disabled={disabled || impedeRemocao}
              />
              <label className="form-check-label" htmlFor={`${id}-motivo-${motivo.id}`}>
                {motivo.motivo}
              </label>
            </div>
          );
        })}
      </div>

      {idsSelecionados.length > 0 && (
        <small className="text-secondary d-block mt-3">
          {idsSelecionados.length} motivo(s) MBA selecionado(s).
        </small>
      )}
    </fieldset>
  );
}

export default MotivosMbaSelector;
